import React, { useEffect, useState } from 'react';
import styles from './Pagination.module.scss';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function PaginationComponent({
  handlePaginationCall,
  totalCounts,
  itemsPerPages,
  pageNumberLimits,
  currentPages,
}) {
  const [currentPage, setcurrentPage] = useState(currentPages || 1);

  useEffect(() => {
    setcurrentPage(currentPages);
  }, [currentPages]);

  const totalPages = Math.ceil(totalCounts / itemsPerPages);

  const handleNextbtn = () => {
    scrollTo(0, 300);
    const newPage = Number(currentPage) + 1;
    setcurrentPage(newPage);
    handlePaginationCall(newPage);
  };

  const handlePrevbtn = () => {
    scrollTo(0, 300);
    const newPage = Number(currentPage) - 1;
    setcurrentPage(newPage);
    handlePaginationCall(newPage);
  };

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  const calculateLimits = () => {
    const halfPageLimits = Math.floor(pageNumberLimits / 2);
    let minLimit = Math.max(1, currentPage - halfPageLimits);
    let maxLimit = Math.min(totalPages, minLimit + pageNumberLimits - 1);

    if (maxLimit - minLimit + 1 < pageNumberLimits) {
      minLimit = Math.max(1, maxLimit - pageNumberLimits + 1);
    }
    return { minLimit, maxLimit };
  };

  const { minLimit, maxLimit } = calculateLimits();

  return (
    <>
      <ul className={styles.pageNumbers}>
        <div
          className={
            currentPage == 1
              ? styles.paginationButtonDisable
              : styles.paginationButton
          }
          onClick={currentPage != 1 ? handlePrevbtn : () => {}}
        >
          <ArrowBackIcon className={styles.arrowIcon} />
        </div>

        {renderPageNumbers()
          .filter((number) => number >= minLimit && number <= maxLimit)
          .map((number) => (
            <li
              key={number}
              onClick={() => {
                setcurrentPage(number);
                handlePaginationCall(number);
              }}
              className={
                currentPage == number
                  ? styles.activeNumber
                  : styles.inActiveNumber
              }
            >
              {String(number).padStart(2, '0')}
            </li>
          ))}

        <div
          className={
            currentPage == totalPages
              ? styles.paginationButtonDisable
              : styles.paginationButton
          }
          onClick={currentPage != totalPages ? handleNextbtn : () => {}}
        >
          <ArrowForwardIcon className={styles.arrowIcon} />
        </div>
      </ul>
    </>
  );
}

export default PaginationComponent;
